<template>
	<el-form-item
		prop="selectBandwidthPackage"
		class="net-select"
		:label="$t('eip.text.joinShareBandwidth') | withColon">
		<el-select 
			v-model="bandwidthForm.selectBandwidthPackage"
			class="select-vpc"
			:loading="bandwidthPackageLoading"
			@change="bandwidthPackageChange"
			@visible-change="getRealTimeBandwidthPackage"
			:placeholder="$t('listPage.placeholder.choose')">
			<el-option 
				v-for="(item, index) in bandwidthPackageList" 
				:key="index" 
				:label="item.name"
				:value="item.bandwidthPackageId">
			</el-option>
		</el-select>
		<el-button type="text" @click="jumpToSbwList">
			{{ $t('create.text.createBandwidth') }}
		</el-button>
		<el-tooltip 
			style="margin-left:10px"
			effect="dark"
			placement="right"
			content="Right Top">
			<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.joinShareBandwidth')}}
			</div>
			<a><i class="jc-icon-question"></i></a>
		</el-tooltip>
	</el-form-item>
</template>

<script>
import {
	SbwAddIpMaxCount
} from '@/common/Constants';
export default {
	data() {
		this.SbwAddIpMaxCount = SbwAddIpMaxCount;
		return {
			bandwidthPackageList: [],
			bandwidthPackageLoading: false,
		};
	},
	model: {
		prop: 'bandwidthForm',
		event: 'selectBandwidthPackage'
	},
	props: {
		bandwidthForm: {
			type: Object,
			default: {}
		},
		region: {
			type: String,
			default: ''
		},
		lineType: {
			type: String,
			default: ''
		}
	},
	methods: {
		/**
			* 加入共享带宽下拉框
		*/
		bandwidthPackageChange(id) {
			let selectBandwidthPackage = this.bandwidthPackageList.filter(item=>item.bandwidthPackageId === id).reduce((obj, curr) => {
				obj.selectBandwidthPackage = curr.bandwidthPackageId;
				obj.selectBandwidthPackageName = curr.name;
				obj.selectBandwidthPackageBandwidth = curr.bandwidth;
				return obj
			},{});
			this.$emit('selectBandwidthPackage',selectBandwidthPackage)
		},
		/**
		 * 下拉操作后确保为最新共享带宽数据
		 * @param tag
		 */
		getRealTimeBandwidthPackage(isVisible) {
			if (isVisible) {
				this.bandwidthPackageLoading = true;
				const param = {
					region: this.region,
					pageNumber: 1,
					pageSize: 20,
					billingStatus: 'stop',
					lineType: this.lineType
				};
				Ajax.get('/api/cps/listBandwidthPackages',param).then((res) => {
					this.bandwidthPackageLoading = false;
					let list;
					if (res.data.bandwidthPackages.length) {
						list = res.data.bandwidthPackages.filter(item => item.ipCount < this.SbwAddIpMaxCount);
					} else {
						list = []
					}
					this.bandwidthPackageList = list;
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
					this.bandwidthPackageLoading = false;
	        	});
			}
		},
		/**
		 * 跳转到共享带宽列表页
		*/
		jumpToSbwList() {
			const { href } = this.$router.resolve({
				name: 'SbwList'
			});
			window.open(href, '_blank');
		},
	}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/common/selectBandwidthPackage/SelectBandwidthPackage.vue